module.exports = __webpack_public_path__ + "media/images/nutri_ads/restilen_300x250_2-701f6b9a76e674d687ac358860aec0da.jpg";